export default __webpack_public_path__ + "static/media/qand.a0db7503.png";